import React, { Component } from 'react';
import './ConfirmModal.css';

import { Button } from '../buttons/Button';

export const ConfirmationModal = ({
    headerTitle,
    bodyText,
    onCancel,
    cancelButtonText,
    onConfirm,
    confirmButtonText,
    enableInput,
    inputLabel,
    inputPlaceholder,
    onInputChange,
}) => {
    return (
        <div className="dialog-container">
            <div className="dialog-body">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLongTitle">
                        {headerTitle}
                    </h5>
                    <Button classes="close" onClick={onCancel ? onCancel : ''} />
                </div>
                <div className="modal-body">
                    {bodyText}
                    {enableInput && (
                        <div className="form-group">
                            <label>{inputLabel}</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={inputPlaceholder}
                                onChange={onInputChange}
                            />
                        </div>
                    )}
                </div>
                <div className="modal-footer">
                    {onCancel && cancelButtonText && (
                        <Button
                            classes="btn btn-secondary"
                            title={cancelButtonText}
                            onClick={onCancel}
                        />
                    )}

                    {onConfirm && confirmButtonText && (
                        <Button
                            classes="btn btn-danger"
                            title={confirmButtonText}
                            onClick={onConfirm}
                        />
                    )}
                </div>
            </div>
            <div className="dialog-screen-shade" />
        </div>
    );
};
